import { useEffect } from "react";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";

export const usePageTitle = (title) => {
  useEffect(() => {
    document.title = title;
  }, [title]);
};

export const Layout = ({ children }) => (
  <div className="min-h-screen flex flex-col">
    <Header />
    <main className="flex-1">{children}</main>
    <Footer />
  </div>
);

export const Loading = () => (
  <div className="min-h-[50vh] flex items-center justify-center text-muted-foreground text-sm" data-testid="loading-state">Loading…</div>
);
